import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=61b6f926"
import script from "./UserCard.ts?vue&type=script&lang=ts&external"
export * from "./UserCard.ts?vue&type=script&lang=ts&external"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=61b6f926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports